import Icon from '@ant-design/icons';

import { ReactComponent as IconHiSvg } from '../../assets/svg/icon-hi.svg';
import { ReactComponent as IconCircleSvg } from '../../assets/svg/icon-circle.svg';
import { ReactComponent as CheckSuccessIcon } from '../../assets/svg/icon-check-success.svg';
import { ReactComponent as IconItemSvg } from '../../assets/svg/icon-item.svg';
import { ReactComponent as IconSearchSvg } from '../../assets/svg/icon-search.svg';
import { ReactComponent as IconQuestionSvg } from '../../assets/svg/icon-question.svg';
import { ReactComponent as IconHandlebookSvg } from '../../assets/svg/icon-handlebook.svg';
import { ReactComponent as IconPhoneSvg } from '../../assets/svg/icon-phone.svg';

const IconHi = (props: any) => <Icon component={IconHiSvg} {...props}></Icon>;
const IconCircle = (props: any) => <Icon component={IconCircleSvg} {...props}></Icon>;
const IconProcess = (props: any) => <Icon component={props.component} {...props}></Icon>;
const CheckSuccess = (props: any) => <Icon component={CheckSuccessIcon} {...props}></Icon>;
const ItemIcon = (props: any) => <Icon {...props} component={IconItemSvg}></Icon>;
const IconSearch = (props: any) => <Icon {...props} component={IconSearchSvg}></Icon>;
const IconQuestion = (props: any) => <Icon {...props} component={IconQuestionSvg}></Icon>;
const IconHandlebook = (props: any) => <Icon {...props} component={IconHandlebookSvg}></Icon>;
const IconPhone = (props: any) => <Icon {...props} component={IconPhoneSvg}></Icon>;

export { IconHi, IconCircle, IconProcess, CheckSuccess, ItemIcon, IconSearch, IconQuestion, IconHandlebook, IconPhone };
